import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DescadastroEmailService } from '../shared/service/descadastro-email.service';
import { ResultadoDescadastroEnum } from '../shared/model/descadastro/descadastro-email-resultado.model';

@Component({
  selector: 'app-descadastro-email',
  standalone: true,
  imports: [],
  templateUrl: './descadastro-email.component.html',
  styleUrl: './descadastro-email.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescadastroEmailComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly descadastroEmailService = inject(DescadastroEmailService);

  protected readonly ResultadoDescadastroEnum = ResultadoDescadastroEnum;

  protected readonly carregando = signal(true);
  protected readonly resultado = signal<ResultadoDescadastroEnum>(ResultadoDescadastroEnum.LINK_INVALIDO);
  protected readonly email = signal('');

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    const email = this.route.snapshot.queryParamMap.get('email');

    if (!uuid || !email) {
      this.carregando.set(false);
      return;
    }

    this.descadastroEmailService.confirmarDescadastro(uuid, email).subscribe({
      next: resposta => {
        this.resultado.set(resposta.resultado ?? ResultadoDescadastroEnum.LINK_INVALIDO);
        this.email.set(resposta.email ?? email);
        this.carregando.set(false);
      },
      error: () => {
        this.resultado.set(ResultadoDescadastroEnum.LINK_INVALIDO);
        this.carregando.set(false);
      }
    });
  }
}
